import styled from 'styled-components'
import { COLORS } from 'utils'

export interface FormStyles {
  marginLeft?: string
  marginRight?: string
  marginBottom?: string
  marginTop?: string
  padding?: string
  boxShadow?: string
}

export const CustomForm = styled.form<FormStyles>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ marginTop }) => marginTop || 0};
  margin-left: ${({ marginLeft }) => marginLeft ?? 0};
  margin-right: ${({ marginRight }) => marginRight ?? 0};
  margin-bottom: ${({ marginBottom }) => marginBottom ?? 0};
  padding: ${({ padding }) => padding};
  background-color: ${COLORS.white};
  box-shadow: ${({ boxShadow }) => boxShadow};
`
